import React, { useEffect, useState } from 'react';
import cn from 'classnames';
import { toast } from 'react-toastify';

import { changeProfileData } from 'services/user';
import { useDispatch } from 'store';
import { fetchProfileData } from 'store/usersReducer';
import YM from 'utils/metrics';
import { validateValue, VALIDATION_TYPES } from 'utils/validation';
import Button from 'components/Button';
import InputPhone from 'components/Input/InputPhone';
import Modal from '../';
import classes from './modalChangePhone.module.scss';
import { IModalChangePhone } from './types';

const ModalChangePhone: React.FC<IModalChangePhone> = ({
	className,
	isOpen,
	onClose,
}) => {
	const dispatch = useDispatch();
	const [phone, setPhone] = useState('');
	const [error, setError] = useState('');
	const [isLoading, setIsLoading] = useState(false);

	const resetFormData = () => {
		setPhone('');
		setError('');
	};

	useEffect(() => {
		if (!isOpen) {
			resetFormData();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isOpen]);

	const validatePhone = (value: string): boolean => {
		const newError = validateValue({
			type: VALIDATION_TYPES.PHONE,
			value,
			isRequired: true,
		});
		setError(newError);
		const isValid = !newError;
		return isValid;
	};

	const handleChangePhone = (value: string): void => {
		setPhone(value);
		validatePhone(value);
	};

	const handleSubmit = async (
		e: React.FormEvent<HTMLFormElement>
	): Promise<void> => {
		e.preventDefault();
		if (isLoading) return;

		const isValid = validatePhone(phone);
		if (!isValid) return;

		setIsLoading(true);
		try {
			await changeProfileData({ phone });
			YM.onFormSubmit();
			await dispatch(fetchProfileData()).unwrap();
			toast.success('Номер телефона успешно изменен');
			onClose();
		} catch (e) {
			toast.error('Не удалось изменить номер телефона');
		}
		setIsLoading(false);
	};

	const form = (
		<form className={classes.form} onSubmit={handleSubmit}>
			<InputPhone
				className={classes.phone}
				value={phone}
				onChange={handleChangePhone}
				placeholder="Номер телефона"
				error={error}
			/>
			<div className={classes.buttons}>
				<Button
					className={classes.buttonSubmit}
					text="Сохранить"
					type="submit"
					isLoading={isLoading}
				/>
				<Button
					className={classes.buttonCancel}
					text="Отмена"
					styleType="secondary"
					onClick={onClose}
				/>
			</div>
		</form>
	);

	return (
		<Modal
			className={cn(classes.modalChangePhone, className)}
			isOpen={isOpen}
			onClose={onClose}
		>
			<div className={classes.title}>
				Введите ваш новый номер телефона
			</div>
			{form}
		</Modal>
	);
};

export default ModalChangePhone;
